import React, { memo, useState } from 'react'
import { Button, Grid, Menu, Popover } from '@arco-design/web-react'
import useLocale from '@/hooks/useLocale'
import styles from '@/style/layout.module.less'
import { useSelector } from 'react-redux'
import { getClientHeight } from '@/store/slices/appSlice'
import { useContext } from 'react'
import { GlobalContext } from '@/context'
const { Col, Row } = Grid
const SubMenu = Menu.SubMenu
const MenuItem = Menu.Item
const MenuItemGroup = Menu.ItemGroup

function MenuWithPopover({
  route,
  visibleChildren,
  onClickMenuItem,
  setRouteMap,
  parentNode,
  type = 2, //类型，1：弹出按钮 2：弹出分组菜单
  onChildChangeVisible = undefined,
}) {
  const { lang } = useContext(GlobalContext)
  const [visible, setVisible] = useState(false)
  const clientHeight = useSelector(getClientHeight)
  const locale = useLocale()
  function getIconFromKey(route) {
    if (!route.Icon) return null
    const Icon = route.Icon
    return <Icon className={styles.icon} />
  }
  function getMenuTitleNoIcon(r) {
    const title = !lang || lang == 'zh-CN' ? r.name : r.nameEn
    const titledom = <>{title}</>
    return titledom
  }
  function getMenuTitle(r) {
    const title = !lang || lang == 'zh-CN' ? r?.name : r?.nameEn
    if (!title && !r?.Icon) return undefined
    const iconDom = getIconFromKey(r)
    const titleDom = (
      <>
        {iconDom} {title}
      </>
    )
    return titleDom
  }
  function getChildMenuTitle(r) {
    const title = !lang || lang == 'zh-CN' ? r?.name : r?.nameEn
    if (!title && !r?.Icon) return undefined
    const iconDom = getIconFromKey(r)
    const titleDom = (
      <>
        {iconDom}{' '}
        <span style={{ color: '#288ccc', fontSize: 16, fontWeight: 900 }}>
          {title}
        </span>
      </>
    )
    return titleDom
  }
  const onChangeVisible = () => {
    setVisible(false)
  }
  const deepSetRouteMap = (item, parentNodeTitles) => {
    for (let j = 0; j < item.children.length; j++) {
      const child = item.children[j]
      const title = !lang || lang == 'zh-CN' ? item.name : item.nameEn
      setRouteMap(child, [...parentNodeTitles, title])

      if (child?.children) {
        deepSetRouteMap(child, parentNodeTitles)
      }
    }
  }
  const renderContent = () => {
    const group = []
    const routeDefault = { key: '', name: '', children: [] }
    group.push(routeDefault)
    for (let i = 0; i < visibleChildren.length; i++) {
      const item = visibleChildren[i]
      setRouteMap(item, parentNode)
      if (item.ignore) continue
      if (!item.children || item.children.length == 0) {
        routeDefault.children.push(item)
      } else {
        if (item.children) {
          deepSetRouteMap(item, [...parentNode, item.name])
        } else {
          deepSetRouteMap(item, [...parentNode])
        }

        group.push(item)
      }
    }

    return (
      <div style={{ maxHeight: clientHeight - 80 + 'px', overflow: 'auto' }}>
        <div style={{ height: 'auto', width: '100%' }}>
          {group.map((g, i) => {
            if (
              g.children &&
              g.children.filter((c) => c.ignore).length == g.children.length
            ) {
              return
            }
            return (
              <div key={i}>
                <div
                  style={{
                    padding: '4px 0',
                    fontWeight: '500',
                    color: '#999',
                  }}
                >
                  {getMenuTitle(g)}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {g.children.map((item, index) => {
                    if (item.ignore) return

                    return (
                      <Button
                        style={{ width: '180px', margin: '4px 8px' }}
                        key={index}
                        className="menu-btn"
                        type="default"
                        long
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          !item.children && onClickMenuItem(item.key)
                          !item.children && onChangeVisible()
                          !item.children &&
                            onChildChangeVisible &&
                            onChildChangeVisible()
                        }}
                      >
                        {item.children ? (
                          <MenuWithPopover
                            type={1}
                            setRouteMap={setRouteMap}
                            parentNode={[...parentNode, g.name, item.name]}
                            key={item.key}
                            route={item}
                            visibleChildren={item.children}
                            onClickMenuItem={(routekey) => {
                              onClickMenuItem(routekey)
                            }}
                            onChildChangeVisible={onChangeVisible}
                          />
                        ) : (
                          getMenuTitleNoIcon(item)
                        )}
                      </Button>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
  const renderPopMenuGroup = () => {
    const group = []
    let falg = route?.children.every((item) => item.children)
    const routeDefault = {
      key: '0',
      name: parentNode[parentNode?.length - 1],
      children: [],
    }
    group.push(routeDefault)
    for (let i = 0; i < visibleChildren.length; i++) {
      const item = visibleChildren[i]
      setRouteMap(item, parentNode)
      if (item.ignore) continue
      if (!item.children || item.children.length == 0) {
        routeDefault.children.push(item)
      } else {
        // for (let j = 0; j < item.children.length; j++) {
        //   const child = item.children[j]
        //   const title = !lang || lang == 'zh-CN' ? item.name : item.nameEn
        //   setRouteMap(child, [...parentNode, title])
        // }
        if (item.children) {
          deepSetRouteMap(item, [...parentNode, item.name])
        } else {
          deepSetRouteMap(item, [...parentNode])
        }
        group.push(item)
      }
    }
    return group.map((g, i) => {
      if (
        g.children &&
        g.children.filter((c) => c.ignore).length == g.children.length
      ) {
        return
      }
      return (
        <MenuItemGroup key={i} title={getChildMenuTitle(g)}>
          {g.children.map((item, index) => {
            if (item.ignore) return
            if (item.children) {
              return (
                <MenuWithPopover
                  type={2}
                  setRouteMap={setRouteMap}
                  parentNode={[...parentNode, g.name, item.name]}
                  key={item.key}
                  route={item}
                  visibleChildren={item.children}
                  onClickMenuItem={(routekey) => {
                    onClickMenuItem(routekey)
                  }}
                />
              )
            }
            return (
              <MenuItem key={item.key}>{getMenuTitleNoIcon(item)}</MenuItem>
            )
          })}
        </MenuItemGroup>
      )
    })
  }
  const titleDom = getMenuTitle(route)

  return type == 1 ? (
    <Popover
      className={'menu-popup menu-popup-3'}
      style={{ maxWidth: '700px' }}
      key={route.key}
      position="right"
      title={titleDom}
      content={renderContent()}
      popupVisible={visible}
      onVisibleChange={setVisible}
      triggerProps={{
        // mouseLeaveDelay: 400,
        // mouseEnterDelay: 400,
        position: 'right',
      }}
    >
      <SubMenu
        key={route.key}
        title={titleDom}
        triggerProps={{
          trigger: [],
          position: 'right',
        }}
      ></SubMenu>
    </Popover>
  ) : (
    <SubMenu
      popup={true}
      key={route.key}
      title={titleDom}
      triggerProps={{
        className: 'menu-group-popup',
        position: 'right',
      }}
    >
      {renderPopMenuGroup()}
    </SubMenu>
  )
}
export default memo(MenuWithPopover)

